import { render, staticRenderFns } from "./UserArticlesSettings.vue?vue&type=template&id=3d31670a"
import script from "./UserArticlesSettings.vue?vue&type=script&lang=js"
export * from "./UserArticlesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports